import {Actions} from '../constants';
import api from '../apiClient';
import {immutableToLocalStorage, removeFromLocalStorage} from '../../utils'
import {defaultAsyncActionFactory} from './action-utils'
import {Keys} from "../constants/keys";
import {loadAssignees} from './assignee-actions';
import {loadWorkSessions, loadLastActiveSession} from './work-session-actions';
import {loadWorkSessionTemplates} from './work-session-template-actions';
import {loadWorkSessionItems} from "./item-actions";
import * as Immutable from "immutable";

export const requestLogin = () => {
    return {type: Actions.LOGIN_USER_REQUEST}
};
export const getAccount = defaultAsyncActionFactory(Actions.GET_ACCOUNT,)
export const doLogin = (username, password, onSuccess) => (dispatch, getState) => {
    dispatch({type: Actions.LOGIN_SERVER_REQUEST});
    return api.login(username, password)
        .then((data) => {
            dispatch({type: Actions.LOGIN_SUCCESS});
            console.log('Saving login state: ', getState().loginState);
            immutableToLocalStorage('loginState', getState().loginState)
            dispatch({type: Actions.GET_ACCOUNT_SUCCESS, payload: {[Keys.StoreSliceData.ACCOUNT]: data.data}});
            // console.log('Saving account state: ', getState().accountState);
            // immutableToLocalStorage('accountState', getState().accountState)

            if (typeof onSuccess === 'function') {
                onSuccess();
            }
        })
        .catch(
            error => {
                dispatch({type: Actions.LOGIN_FAILURE, payload: {message: error.message}});
                if (error.code === 401) {
                    dispatch({type: Actions.LOGIN_USER_REQUEST});
                }
                return Promise.reject(error);
            }
        );
};
export const doLogout = () => (dispatch) => {
    dispatch({type: Actions.LOGOUT_REQUEST});
    removeFromLocalStorage('loginState');
    return api.logout()
        .then(() => {
            dispatch({type: Actions.LOGOUT_SUCCESS});
            dispatch({type: Actions.LOGIN_ABORT})
        })
        .catch(
            (error) => {
                // if real error, we should clear the cookie at least
                dispatch({type: Actions.LOGOUT_SUCCESS});
                dispatch({type: Actions.LOGIN_ABORT})
            }
        );
};
export const doPostLogin = (autoLoadWorkSession, router, redirectTo) => (dispatch, getState) => {
    return Promise.all(
        [
            dispatch(loadAssignees()),
            dispatch(loadWorkSessions()),
            dispatch(loadWorkSessionTemplates()),
        ]).then(() => {
        console.log("PostLogin Done")
        if( autoLoadWorkSession) {
            return dispatch(loadLastActiveSession())
                .then(() => {
                const workSessionId = getState().currentWorkSessionState.get(Keys.StoreSliceData.CURRENT_WORK_SESSION, Immutable.Map()).get(Keys.ID, null);

                    if( workSessionId) {
                    console.log("Open work-session found");
                    router.push(redirectTo);
                    if(process.env.REACT_APP_NO_AUTOUPDATE) {
                        return;
                    }
                    return dispatch(loadWorkSessionItems(workSessionId));
                } else {
                    console.log("No open work-session")
                }
            })
        }
    });
}

export const doLoginAbort = () => {
    return {type: Actions.LOGIN_ABORT}
};





// WEBPACK FOOTER //
// ./src/model/action-creators/login-actions.js